export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-icon/index.js